/**
 * Dialog size options.
 * Maps to NeoDialog size values.
 */
export enum DialogSize {
  sm = 'sm',
  md = 'md',
  lg = 'lg',
}

/**
 * Configuration options for custom dialogs.
 * Used with DialogProvider.open() method.
 *
 * @example
 * ```typescript
 * const options: DialogOptions<MyData> = {
 *   size: DialogSize.md,
 *   data: { id: '123' },
 *   disableClose: true,
 * };
 * ```
 */
export interface DialogOptions<TData = unknown> {
  /**
   * Dialog size.
   * @default DialogSize.md
   */
  size?: DialogSize;

  /**
   * Data passed to the dialog component via NEO_DIALOG_DATA injection token.
   */
  data?: TData;

  /**
   * Prevents dialog from being closed via ESC key or backdrop click.
   * User must explicitly use a button or close method.
   * @default false
   */
  disableClose?: boolean;

  /**
   * Whether to show a backdrop behind the dialog.
   * @default true
   */
  hasBackdrop?: boolean;

  /**
   * Custom CSS class to apply to the dialog panel.
   * Use for dialog-specific styling.
   */
  panelClass?: string;

  /**
   * Custom dialog width. Overrides the size setting if provided.
   * @example '720px', '50vw'
   */
  width?: string;
}
